import { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from "@material-ui/core";
import { GetApp as GetAppIcon } from "components/MaterialSymbol/MaterialIcons";
import { Description as DescriptionIcon } from "components/MaterialSymbol/MaterialIcons";
import { MonetizationOn as MonetizationOnIcon } from "components/MaterialSymbol/MaterialIcons";
import ReportService from "services/ReportService";

// Constantes de acciones
const EXPORT_TYPES = {
    ORDERS: "orders",
    COSTS: "costs",
};

// Opciones de exportación
const EXPORT_OPTIONS = [
    {
        label: "Orders",
        icon: <DescriptionIcon fontSize="small" />,
        action: EXPORT_TYPES.ORDERS,
    },
    {
        label: "Costs",
        icon: <MonetizationOnIcon fontSize="small" />,
        action: EXPORT_TYPES.COSTS,
    },
];

export default function ExportSalesDropdownButton({
    dealerIds = [],
    startDate = "",
    endDate = "",
    disabled = false,
}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleExport = (type) => {
        if (type === EXPORT_TYPES.ORDERS) {
            ReportService.exportOrderMarginSummaryCSV(dealerIds, startDate, endDate);
        } else if (type === EXPORT_TYPES.COSTS) {
            ReportService.exportDealerSalesSummaryCSV(dealerIds, startDate, endDate);
        }
        handleClose();
    };

    const tooltipMessage = `No orders found between ${startDate || "start date"} and ${
        endDate || "end date"
    }`;

    const exportButton = (
        <Button
            variant="contained"
            size="small"
            startIcon={<GetAppIcon />}
            onClick={handleClick}
            disabled={disabled}
            style={{ textTransform: "uppercase", fontWeight: "bold" }}
        >
            Export CSV
        </Button>
    );

    return (
        <>
            {disabled ? (
                <Tooltip title={tooltipMessage} arrow>
                    <span>{exportButton}</span>
                </Tooltip>
            ) : (
                exportButton
            )}

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                elevation={3}
            >
                {EXPORT_OPTIONS.map(({ label, icon, action }) => (
                    <MenuItem key={action} onClick={() => handleExport(action)}>
                        <ListItemIcon style={{ minWidth: 30 }}>{icon}</ListItemIcon>
                        <ListItemText primary={label} primaryTypographyProps={{ noWrap: true }} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
